import { render, staticRenderFns } from "./doc2.vue?vue&type=template&id=6b7d51bc"
import script from "./doc2.vue?vue&type=script&lang=js"
export * from "./doc2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports